import React, { Component } from 'react';
import { RaisedButton, FlatButton } from 'material-ui';
import { Row, Col } from 'react-flexbox-grid';
import MenuItem from 'material-ui/MenuItem';
import * as actions from '../.././actions';
import autoBind from 'react-autobind';
import { Field, reduxForm } from 'redux-form';
import validator from 'validator';
import { TextField, SelectField } from 'redux-form-material-ui';

const validate = values => {
    const errors = {};

    if (validator.isEmpty(values.password1 ? values.password1 : "") === false) {
        if (validator.isLength(values.password1, 6) === false) {
            errors.password1 = 'Mật khẩu phải 6 ký tự trở lên';
        }
    }

    errors.password2 = validator.equals(values.password2 ? values.password2 : "", values.password1 ? values.password1 : "") ? null : 'Mật khẩu không trùng khớp';
    const requiredFields = ['firstname', 'lastname', 'projectId'];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Không được để trống';
        }
    })

    if (validator.isEmpty(values.mail) === false) {
        if (validator.isEmail(values.mail) === false) {
            errors.mail = 'Không phải là địa chỉ mail';
        }
    } else {
        errors.mail = 'Không được để trống';
    }
    return errors;
}

export class EditUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            password1: '',
            password2: '',
            mail: this.props.user.mail,
            firstname: this.props.user.firstname,
            lastname: this.props.user.lastname,
            projectId: this.props.user.projectId,
            id: this.props.user.id,
        };
        autoBind(this);
    }

    handleEditUser({ password1, password2, mail, lastname, firstname, projectId }) {
        this.state.password1 = password1;
        this.state.password2 = password2;
        this.state.mail = mail;
        this.state.lastname = lastname;
        this.state.firstname = firstname;
        this.state.projectId = projectId;
        this.props.dispatch(actions.editUser(this.state, false));
        this.props.handleClose();
    }

    handleChangeLevel(event, index, value) {
        this.setState({
            projectId: value
        });
    }

    render() {
        const { handleSubmit, pristine, submitting } = this.props;
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <Row>
                            <Col xs={6}>
                                <Field
                                    name="password1"
                                    component={TextField}
                                    hintText="Mật khẩu"
                                    floatingLabelText="Mật khẩu"
                                    fullWidth={true}
                                    underlineShow={true}
                                    type="password"
                                />
                                <Field
                                    name="password2"
                                    component={TextField}
                                    hintText="Xác nhận mật khẩu"
                                    floatingLabelText="Xác nhận mật khẩu"
                                    fullWidth={true}
                                    underlineShow={true}
                                    type="password"
                                />
                                <Field
                                    name="mail"
                                    component={TextField}
                                    hintText="Email"
                                    floatingLabelText="Email"
                                    fullWidth={true}
                                    underlineShow={true}
                                />
                            </Col>
                            <Col xs={6}>
                                <Field
                                    name="lastname"
                                    component={TextField}
                                    hintText="Họ"
                                    floatingLabelText="Họ"
                                    fullWidth={true}
                                    underlineShow={true}
                                />
                                <Field
                                    name="firstname"
                                    component={TextField}
                                    hintText="Tên"
                                    floatingLabelText="Tên"
                                    fullWidth={true}
                                    underlineShow={true}
                                />
                                <Field
                                    name="projectId"
                                    component={SelectField}
                                    hintText="Dự án"
                                    floatingLabelText="Dự án"
                                >
                                    < MenuItem value={63} primaryText="Itracking" />
                                    < MenuItem value={65} primaryText="Smartbike" />
                                </Field>
                            </Col>
                        </Row>
                        <div style={{ marginTop: '10%' }}>
                            <Row>
                                <Col xs={12}>
                                    <Row center='xs'>
                                        <Col xs={4}>
                                            <Row>
                                                <Col xs>
                                                    <FlatButton
                                                        label="Hủy"
                                                        onTouchTap={this.props.handleClose}
                                                    />
                                                </Col>
                                                <Col xs>
                                                    <RaisedButton
                                                        label="Sửa"
                                                        primary={true}
                                                        keyboardFocused={true}
                                                        disabled={pristine || submitting}
                                                        onTouchTap={handleSubmit(this.handleEditUser)}
                                                    />
                                                </ Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default reduxForm({
    form: 'editUser', // a unique identifier for this form
    validate,
    // asyncValidate,
})(EditUser);


// WEBPACK FOOTER //
// ./src/components/users/edit.js